<script setup lang="ts">
import { capitalize } from 'lodash-es'

const route = useRoute()
const config = useRuntimeConfig()
const appConfig = useAppConfig()

const glossary = config.public.blog.glossary
const origin = config.public.host
const blog = appConfig.blog
const category = route.params.category
const pathName = route.fullPath
const id = useRemoveTrailingSlash((route.params.id as string[]).join('/'))
const canonical = new URL(route.path, config.public.host)
const blogApi = useStoryblokBlog()
const storyblokApi = useStoryblokApiV2()

const homePage = (await blogApi.getHome()).homePage.content
const glossaryPage = (await storyblokApi.getStory({ by_slug: `pages/${glossary}/${category}` }))
const glossaryArticleItem = await storyblokApi.getStory({ by_slug: `blog/${glossary}/${category}/${id}` })

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
})

useHead({
  title: `${glossaryArticleItem.title} | ${config.public.siteName}`,
  meta: [
    { name: 'description', content: glossaryArticleItem?.metaDescription || '' },
    { property: 'og:title', content: glossaryArticleItem?.title },
    { property: 'og:type', content: 'article' },
    { property: 'og:url', content: origin + pathName },
    { property: 'og:site_name', content: `${config.public.siteName}` },
    { property: 'article:publisher ', content: `https://www.facebook.com/${config.public.siteName.toLowerCase()}/` },
  ],
  link: [{
    rel: 'canonical',
    href: canonical.origin + canonical.pathname,
  }],
})

const breadcrumbs = useState('breadcrumbs')
breadcrumbs.value = { breadcrumbs: [{ slug: `${blog.url}/`, title: capitalize(blog.url.substring(1)) }, { slug: `${glossary}/${category}/`, title: blog.glossaryTitle }], title: `${glossaryArticleItem?.title}` }
</script>

<template>
  <BlogWrapper :blog-homepage-items="homePage">
    <h2>{{ glossaryPage?.title }}</h2>
    <h3 class="mt-2.5 mb-2">
      {{ glossaryPage?.tilesTitle }}
    </h3>
    <BlogRightPanelWrapper
      :top-articles="homePage.topArticles"
      :most-read-articles="homePage.mostReadArticles"
      :nepodcento="homePage.nepodcento[0]"
    >
      <div class="grid grid-cols-2 gap-2.5 md:grid-cols-4 mt-5">
        <StoryblokProductTile
          v-for="item in glossaryPage?.tiles"
          :item="item"
          :is-active="item.text.toLowerCase() === category.toLowerCase()"
        />
      </div>
      <div class="bg-white p-10 rounded-xl mt-5">
        <StoryblokLink :to="`/${glossary}/${category}`" class="flex items-center text-primary text-lg underline mb-5 font-medium hover:underline">
          <AppIcon size="15" icon="far-angle-left" class="mr-1.5" />
          <p>{{ glossaryPage?.goBackButton }}</p>
        </StoryblokLink>
        <h1>{{ glossaryArticleItem?.title }}</h1>
        <StoryblokRichText :document="glossaryArticleItem?.text" class="main-text" />
      </div>
    </BlogRightPanelWrapper>
  </BlogWrapper>
</template>

<style lang="scss" scoped>

</style>
